import { MOBILE_LAYOUT_LENGTH, PC_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -999;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100vw;
    height: 800rem;
    overflow-x: hidden;
  }
`;

export const Img1Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100vw;
  height: 150rem;
`;
export const Img1 = styled.img`
  position: relative;
  width: 200.5rem;
  height: 150.8rem;
  top: -2rem;
  left: 0;
  z-index: -9999;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 85.5rem;
    height: 80.8rem;
    left: 0rem;
    top: -25rem;
  }
`;
export const Img2 = styled.img`
  position: absolute;
  width: 110.6rem;
  height: 100.5rem;
  left: 0rem;
  top: 230.8rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    top: 120.8rem;
    width: 70.6rem;
    height: 80.5rem;
    left: -10rem;
  }
  /* opacity: 0.2; */
  /* transform: matrix(-1, 0, 0, 1, 0, 0); */
`;
export const Img3 = styled.img`
  position: absolute;
  width: 100.6rem;
  height: 99.5rem;
  left: 94rem;
  top: 611.8rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
  /* opacity: 0.2; */
  /* transform: matrix(-1, 0, 0, 1, 0, 0); */
`;

export const Design1 = styled.div`
  position: absolute;
  width: 800px;
  height: 800px;
  left: 456px;
  top: 2468px;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(200px);
  transform: matrix(-1, 0, 0, 1, 0, 0);
`;
export const Design2 = styled.div`
  position: absolute;
  width: 70rem;
  height: 70rem;
  left: 61.4rem;
  top: 54.7rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 195, 246, 0.3) 0%, rgba(33, 195, 246, 0) 100%);
  filter: blur(200px);
`;
export const Design3 = styled.div`
  position: absolute;
  width: 80rem;
  height: 80rem;
  left: 88.8rem;
  top: 42.4rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(200px);
`;
export const Design4 = styled.div`
  position: absolute;
  width: 80rem;
  height: 80rem;
  left: -41.7rem;
  top: 108.974rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(200px);
  transform: rotate(-75deg);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 30rem;
    height: 100rem;
    left: 0rem;
    top: 88.974rem;
  }
`;
export const Design5 = styled.div`
  position: absolute;
  width: 90rem;
  height: 90rem;
  left: 135rem;
  top: 123.7rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(246, 33, 225, 0.3) 0%, rgba(246, 33, 225, 0) 100%);
  filter: blur(200px);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;
export const Design6 = styled.div`
  position: absolute;
  width: 70rem;
  height: 70rem;
  left: -36.911rem;
  top: 138.624rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 195, 246, 0.3) 0%, rgba(33, 195, 246, 0) 100%);
  filter: blur(200px);
  transform: rotate(-75deg);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;

export const Design7 = styled.div`
  position: absolute;
  width: 41.446rem;
  height: 41.446rem;
  left: 30.7rem;
  top: 449.4rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(246, 33, 225, 0.8) 0%, rgba(246, 33, 225, 0) 100%);
  filter: blur(200px);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 30rem;
    left: 0rem;
    top: 509rem;
  }
`;
export const Design8 = styled.div`
  position: absolute;
  width: 41.446rem;
  height: 41.446rem;
  left: 83.7rem;
  top: 502rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(246, 33, 225, 0.8) 0%, rgba(246, 33, 225, 0) 100%);
  filter: blur(200px);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 30rem;
    left: 0rem;
    top: 620rem;
  }
`;
export const Design9 = styled.div`
  position: absolute;
  width: 36.841rem;
  height: 36.841rem;
  left: 60.909rem;
  top: 457.321rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.8) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(200px);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 30rem;
    left: 10rem;
    top: 549rem;
  }
`;
export const Design10 = styled.div`
  position: absolute;
  width: 36.841rem;
  height: 36.841rem;
  left: 113.909rem;
  top: 509.921rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.8) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(200px);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;
export const Design11 = styled.div`
  position: absolute;
  width: 80rem;
  height: 80rem;
  left: -41.7rem;
  top: 623.574rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(200px);
  transform: rotate(-75deg);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;
export const Design12 = styled.div`
  position: absolute;
  width: 70rem;
  height: 70rem;
  left: -36.911rem;
  top: 643.224rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 195, 246, 0.3) 0%, rgba(33, 195, 246, 0) 100%);
  filter: blur(200px);
  transform: rotate(-75deg);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;

export const Design13 = styled.div`
  position: absolute;
  width: 192rem;
  height: 125.6rem;
  left: 0rem;
  top: 438.1rem;

  background: linear-gradient(180deg, #101010 0%, #000000 21.35%, #000000 77.08%, #101010 100%);
  z-index: -9999;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 37.5rem;
    left: 0;
    top: 540rem;
  }
`;
export const Design15 = styled.div``;
